import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'snumber'
})
export class SignedNumberPipe implements PipeTransform {

  constructor(private decimal: DecimalPipe) { }

  transform(value: number, digitsInfo?: string, locale?: string, zeroSign?: '+' | '-'): string {
    return this.sign(value, zeroSign) + this.decimal.transform(value, digitsInfo, locale);
  }

  private sign(value: number, zeroSign: string): string {
    return value > 0 ? '+' : value < 0 ? '' : zeroSign ? zeroSign : '';
  }
}
